export interface ChangelogSection {
  title: string;
  items: string[];
}

export interface ChangelogEntry {
  version: string;
  date: string;
  sections: ChangelogSection[];
}

const VERSION_HEADING = /^#{2,3}\s*\[(\d+\.\d+\.\d+(?:-[^\]]+)?)]\([^)]+\)\s*\((\d{4}-\d{2}-\d{2})\)/;
const SECTION_HEADING = /^###\s+(.+)$/;
const BULLET = /^\*\s+(.+)$/;

function stripMarkdown(text: string): string {
  return text
    .replace(/\[([^\]]*)]\([^)]*\)/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\s*\(\s*\)/g, '')
    .trim();
}

export function parseChangelog(raw: string): ChangelogEntry[] {
  const lines = raw.split(/\r?\n/);
  const entries: ChangelogEntry[] = [];

  let currentEntry: ChangelogEntry | null = null;
  let currentSection: ChangelogSection | null = null;

  for (const line of lines) {
    const versionMatch = VERSION_HEADING.exec(line);
    if (versionMatch) {
      currentEntry = { version: versionMatch[1], date: versionMatch[2], sections: [] };
      entries.push(currentEntry);
      currentSection = null;
      continue;
    }

    if (!currentEntry) {
      continue;
    }

    const sectionMatch = SECTION_HEADING.exec(line);
    if (sectionMatch) {
      currentSection = { title: sectionMatch[1].trim(), items: [] };
      currentEntry.sections.push(currentSection);
      continue;
    }

    const bulletMatch = BULLET.exec(line);
    if (bulletMatch && currentSection) {
      const text = stripMarkdown(bulletMatch[1]);
      if (text) {
        currentSection.items.push(text);
      }
    }
  }

  return entries;
}
